import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-pharmacy-peek-dialog',
    templateUrl: './pharmacy-peek-dialog.component.html',
    styleUrls: ['./pharmacy-peek-dialog.component.scss'],
    standalone: false
})
export class PharmacyPeekDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

}
